export function debounce<T extends (...args: any[]) => void>(
  func: T,
  delay: number,
): (...args: Parameters<T>) => void {
  let inDebounce: ReturnType<typeof setTimeout>;
  return function (this: ThisParameterType<T>, ...args: Parameters<T>) {
    clearTimeout(inDebounce);
    inDebounce = setTimeout(() => {
      func.apply(this, args);
    }, delay);
  };
}

export function debounceAsync<T extends (...args: any[]) => Promise<any>>(
  func: T,
  delay: number,
): (...args: Parameters<T>) => Promise<ReturnType<T>> {
  let inDebounce: ReturnType<typeof setTimeout>;
  let pendingPromise: Promise<ReturnType<T>> | null = null;

  return function (this: ThisParameterType<T>, ...args: Parameters<T>): Promise<ReturnType<T>> {
    if (pendingPromise) {
      return pendingPromise;
    }

    clearTimeout(inDebounce);

    pendingPromise = new Promise<ReturnType<T>>((resolve) => {
      inDebounce = setTimeout(async () => {
        const result = await func.apply(this, args);
        resolve(result);
        pendingPromise = null;
      }, delay);
    });

    return pendingPromise;
  };
}
